import React, { Component } from "react";
import "./NetworkCard.css";

class NetworkCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: this.props.userInfo,
    };
  }

  render() {
    let network = this.props.network;
    return (
      <>
        {this.props.editing ? (
          <div className="network_card_disabled">
            <h1 className="edit_title">{network.name}</h1>
            <div className="network_card_edited"></div>
            {network.description !== "" ? (
              <div className="network_description">
                <p style={{ textAlign: "right" }}>Description</p>
                <div className="network_separator"></div>
                <div className="description">{network.description}</div>
                <div className="network_separator"></div>
              </div>
            ) : null}
            <div className="network_info">
              <p>
                <span>
                  {network.nodes.length} Node
                  {network.nodes.length === 1 ? null : "s"}
                </span>
              </p>
              <p>
                <span>
                  {network.users.length} User
                  {network.users.length === 1 ? null : "s"}
                </span>
              </p>
            </div>
            <div className="network_edit">
              {network.users.length === 1 ? (
                <div className="toolti_right">
                  <button className="edit_delete_button" onClick={()=>{this.props.setDeleteModal(network)}}>Delete Network</button>
                  <span className="tooltitext">
                    {"  "}You are the last user in the network, click to delete{"  "}
                  </span>
                </div>
              ) : (
                <div className="toolti_right">
                  <button className="edit_leave_button" onClick={()=>{this.props.setLeaveModal(network)}}>Leave Network</button>
                  <span className="tooltitext">
                    {"  "}Network contains more users, click to leave{"  "}
                  </span>
                </div>
              )}
            </div>
          </div>
        ) : (
          <a href={this.props.baseDir+"/networks/" + network.uuid + '/'}>
            <div className="network_card">
              <h1>{network.name}</h1>
              {network.description !== "" ? (
                <div className="network_description">
                  <p style={{ textAlign: "right" }}>Description</p>
                  <div className="network_separator"></div>
                  <div className="description">{network.description}</div>
                  <div className="network_separator"></div>
                </div>
              ) : null}
              <div className="network_info">
                <p>
                  <span>
                    {network.nodes.length} Node
                    {network.nodes.length === 1 ? null : "s"}
                  </span>
                </p>
                <p>
                  <span>
                    {network.users.length} User
                    {network.users.length === 1 ? null : "s"}
                  </span>
                </p>
              </div>
            </div>
          </a>
        )}
      </>
    );
  }
}

export default NetworkCard;
